import { useLazyQuery } from '@apollo/react-hooks';
import { GET_DISCUSSIONS } from '../../graphql/discussion/query';
import {
  Discussions,
  DiscussionsVariables,
} from '../../graphql/discussion/types/Discussions';

export const useGetDiscussions = () => {
  return useLazyQuery<Discussions, DiscussionsVariables>(GET_DISCUSSIONS, {
    fetchPolicy: 'cache-and-network',
  });
};
